/**
 * @generated SignedSource<<309f4d62bd850a58613b75bc1e5b17ac>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type components_issueFieldComponentsReadviewFull_ComponentsReadView$data = {
  readonly selectedComponentsConnection: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly label: string | null | undefined;
        readonly value: string;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  };
  readonly " $fragmentType": "components_issueFieldComponentsReadviewFull_ComponentsReadView";
};
export type components_issueFieldComponentsReadviewFull_ComponentsReadView$key = {
  readonly " $data"?: components_issueFieldComponentsReadviewFull_ComponentsReadView$data;
  readonly " $fragmentSpreads": FragmentRefs<"components_issueFieldComponentsReadviewFull_ComponentsReadView">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "components_issueFieldComponentsReadviewFull_ComponentsReadView",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "args": [
          {
            "kind": "Literal",
            "name": "first",
            "value": 1000
          }
        ],
        "concreteType": "JiraComponentConnection",
        "kind": "LinkedField",
        "name": "selectedComponentsConnection",
        "plural": false,
        "selections": [
          {
            "concreteType": "JiraComponentEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "concreteType": "JiraComponent",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": "value",
                    "kind": "ScalarField",
                    "name": "id"
                  },
                  {
                    "alias": "label",
                    "kind": "ScalarField",
                    "name": "name"
                  }
                ]
              }
            ]
          }
        ],
        "storageKey": "selectedComponentsConnection(first:1000)"
      },
      "action": "THROW",
      "path": "selectedComponentsConnection"
    }
  ],
  "type": "JiraComponentsField"
};

(node as any).hash = "35b9643b76a914d7422dfb3f74901db8";

export default node;
